import React from "react"
import { Col, Row } from "react-bootstrap"
import Authenticated from "../../lib/Authenticated"
import AccountingReportLinks from "./AccountingReportLinks"
import FinancierReportLinks from "./financiers/FinancierReportLinks"
import LoanReportLinks from "./LoanReportLinks"

export default function ReportsList() {

  const authenticated = new Authenticated(),
  isSuper = authenticated.isSuper(),
  isAdmin = authenticated.isAdmin(),
  isAccountant = authenticated.isAccountant(),
  isPaymentManager = authenticated.isPaymentManager(),
  canISeeReports = isSuper || isAdmin || isAccountant || isPaymentManager,
  canSeeAccountingReport = isSuper || isAdmin || isAccountant,
  canSeeFinancierReport = isSuper || isAdmin || isAccountant

  if (!canISeeReports) return null
  return (
    <Row>
      <Col md={6}>
        <h4>Loans</h4>
        <LoanReportLinks />
      </Col>

      { canSeeAccountingReport &&
        <Col md={6}>
          <h4>Accounting</h4>
          <AccountingReportLinks />
        </Col>
      }

      { canSeeFinancierReport &&
        <Col md={6}>
          <h4>Financiers</h4>
          <FinancierReportLinks />
        </Col>
      }
    </Row>
  )
}



// WEBPACK FOOTER //
// ./src/components/Reports/ReportsList.js